import _slicedToArray from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef, useEffect, useRef, useState } from 'react';
import * as S from './styles';
import { Typography } from '../Typography';
export var TextFieldInput = forwardRef(function (_a, ref) {
  var floatingLabel = _a.floatingLabel,
      isFieldFocused = _a.isFieldFocused,
      startIcon = _a.startIcon,
      endIcon = _a.endIcon,
      hasError = _a.hasError,
      props = __rest(_a, ["floatingLabel", "isFieldFocused", "startIcon", "endIcon", "hasError"]);

  var floatingLabelRef = useRef(null);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      floatingLabelWidth = _useState2[0],
      setFloatingLabelWidth = _useState2[1];

  var isLabelFloating = isFieldFocused || !!props.value;
  useEffect(function () {
    var _a;

    setFloatingLabelWidth((_a = floatingLabelRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth);
  }, [isLabelFloating]);
  return React.createElement(React.Fragment, null, startIcon, React.createElement(S.TextFieldLabel, {
    hasIcon: !!startIcon,
    hasError: hasError,
    isFloating: isLabelFloating,
    ref: floatingLabelRef,
    focused: isFieldFocused
  }, React.createElement(Typography, null, floatingLabel)), React.createElement(S.TextFieldFieldsetWrapper, {
    onKeyDown: props.onKeyDown,
    hasError: hasError
  }, React.createElement(S.TextFieldInput, Object.assign({
    ref: ref,
    hasStartIcon: !!startIcon,
    hasEndIcon: !!endIcon
  }, props)), React.createElement(S.TextFieldFieldset, {
    hasError: hasError,
    focused: isFieldFocused,
    "aria-hidden": "true"
  }, React.createElement(S.TextFieldLegend, {
    hasIcon: !!startIcon,
    isFloating: isLabelFloating,
    floatingLabelWidth: floatingLabelWidth,
    focused: isFieldFocused
  }, React.createElement(Typography, {
    variant: 'content3'
  }, floatingLabel))), endIcon));
});